import PostListPage from '~components/post-list-page'

export default PostListPage({
  path: '/startup/:startup',
  title: 'Perfiles startup',
  sort: '-karma'
})



// WEBPACK FOOTER //
// ../frontend/pages/post/list-startup.js